import React, { useState } from 'react';
import dayjs from 'dayjs';
import { DayPicker } from 'react-day-picker';
import ModalComponent from 'components/Common/Modal';
const CalendarExpirtyDate = (props) => {
  const { setShowCalendarPicker, visibilityOptions, showCalendarPicker } = props;
  const { date } = visibilityOptions;

  const closeModal = () => {
    setShowCalendarPicker(false);
  };

  const [selectedDay, setSelectedDay] = useState(new Date());
  const [currMonth, setCurrMonth] = useState(new Date());

  const handleDayClick = (day) => {
    setSelectedDay(day);
    date.setValue({
      name: dayjs(day).format('DD MMM[,] YYYY'),
      value: dayjs(day).utc().startOf('day').format().replace('Z', ''),
      selected: true,
    });
    closeModal();
  };

  return (
    <ModalComponent
      style={{ position: 'absolute', top: '29%' }}
      maxWidth={260}
      isOpen={showCalendarPicker}
      setIsOpen={closeModal}
    >
      <div className='modal-calendar'>
        <div className={`calendar-picker tweets-calendar`}>
          <DayPicker
            mode='single'
            onSelect={handleDayClick}
            selected={selectedDay}
            showOutsideDays={false}
            disabled={(day) => day > dayjs().toDate()}
            month={currMonth}
            onMonthChange={(e) => setCurrMonth(e)}
            components={{
              Weekday: (props) => {
                return <th {...props}>{props?.children?.[0]}</th>;
              },
            }}
            ISOWeek
          />
        </div>
      </div>
    </ModalComponent>
  );
};

export default CalendarExpirtyDate;
